import React from 'react';
import { heritageColors } from '../../../../heritageTheme.ts';

const TYPE_CONFIGS = {
  medic: { label: 'חובש', icon: 'medical_services', color: '#2d5a3d', bg: '#e8f5e9', border: '#a5d6a7' },
  paramedic: { label: 'פרמדיק', icon: 'cardiology', color: '#1e3a5f', bg: '#e3f2fd', border: '#90caf9' },
  maar: { label: 'מע"ר', icon: 'healing', color: '#b8860b', bg: '#fff8e1', border: '#ffe082' },
};

/**
 * Banner – תבנית באנרים אופקיים
 * כל כונן ברצועה אופקית מלאה – מתאים למידות רחבות ונותן נוכחות חזקה
 */
const Banner = ({
  initialData = { volunteers: { medic: [], paramedic: [], maar: [] } },
  title = 'חירום והצלה',
  showTitle = true,
}) => {
  const volunteers = initialData.volunteers || { medic: [], paramedic: [], maar: [] };

  const allVolunteers = [
    ...(volunteers.medic || []).map(v => ({ ...v, type: 'medic' })),
    ...(volunteers.paramedic || []).map(v => ({ ...v, type: 'paramedic' })),
    ...(volunteers.maar || []).map(v => ({ ...v, type: 'maar' })),
  ];

  return (
    <div style={{
      padding: '1em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5em',
          paddingBottom: '0.625em',
          marginBottom: '0.75em',
          borderBottom: `0.0625em solid ${heritageColors.emergency}`,
        }}>
          <div style={{
            backgroundColor: heritageColors.emergencyLight,
            borderRadius: '50%',
            padding: '0.3125em',
            display: 'flex',
            border: `0.03125em solid ${heritageColors.emergency}30`,
          }}>
            <span className="material-symbols-outlined" style={{
              color: heritageColors.emergency,
              fontSize: '1.125em',
            }}>ambulance</span>
          </div>
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.emergency,
            fontSize: '0.875em',
          }}>{title}</h3>
        </div>
      )}

      {allVolunteers.length === 0 ? (
        <div style={{ color: heritageColors.emergency, fontSize: '0.875em', textAlign: 'center' }}>
          אין כוננים זמינים
        </div>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5em',
          flex: 1,
          overflow: 'auto',
        }}>
          {allVolunteers.map((v, index) => {
            const config = TYPE_CONFIGS[v.type] || { label: 'כונן', icon: 'support', color: heritageColors.emergency, bg: heritageColors.emergencyLight, border: '#ef9a9a' };
            return (
              <div
                key={v.id || index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75em',
                  padding: '0.625em 0.875em',
                  backgroundColor: config.bg,
                  border: `0.03125em solid ${config.border}`,
                  borderRight: `0.25em solid ${config.color}`,
                  borderRadius: '0.375em',
                }}
              >
                {/* אייקון סוג */}
                <div style={{
                  backgroundColor: config.color,
                  color: '#fff',
                  borderRadius: '50%',
                  width: '2em',
                  height: '2em',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '1.125em' }}>
                    {config.icon}
                  </span>
                </div>

                {/* תג סוג */}
                <span style={{
                  fontSize: '0.625em',
                  color: config.color,
                  fontWeight: 700,
                  backgroundColor: '#fff',
                  padding: '0.1875em 0.5em',
                  borderRadius: '0.1875em',
                  border: `0.03125em solid ${config.border}`,
                  minWidth: '3em',
                  textAlign: 'center',
                }}>
                  {config.label}
                </span>

                {/* שם */}
                <span style={{
                  color: heritageColors.navy,
                  fontWeight: 'bold',
                  fontSize: '0.875em',
                  flex: 1,
                }}>
                  {v.name}
                </span>

                {/* כתובת */}
                {v.address && (
                  <span style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.1875em',
                    color: heritageColors.slate,
                    fontSize: '0.6875em',
                  }}>
                    <span className="material-symbols-outlined" style={{ fontSize: '0.75em' }}>location_on</span>
                    {v.address}
                  </span>
                )}

                {/* טלפון */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.25em',
                  color: heritageColors.emergency,
                  fontWeight: 'bold',
                  fontSize: '0.8125em',
                }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '0.875em' }}>call</span>
                  <span style={{ direction: 'ltr' }}>{v.phone}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Banner;
